export const createPrivateEvent = (name, value) => {
    return { target: { name: name, value: value } }
}

export const formatDateTime = (inputDateTime, format) => {
  if (!inputDateTime) return '';

  const date = new Date(inputDateTime);

  const pad = (n) => n.toString().padStart(2, '0');

  const map = {
    '%d': pad(date.getDate()),              // Day
    '%m': pad(date.getMonth() + 1),         // Month
    '%Y': date.getFullYear(),               // Full year
    '%y': String(date.getFullYear()).slice(-2), // Short year
    '%H': pad(date.getHours()),             // Hours (24h)
    '%I': pad(date.getHours() % 12 || 12),  // Hours (12h)
    '%M': pad(date.getMinutes()),           // Minutes
    '%S': pad(date.getSeconds()),           // Seconds
    '%p': date.getHours() >= 12 ? 'PM' : 'AM', // AM/PM
  };

  return format.replace(/%[dmyYHIMSp]/g, match => map[match] || match);
}


export const formatDateForQuery = (timestamp) => {
    /**
     * Format the timestamp to a more readable format.
     * * @param {string} timestamp - The timestamp is in string to format.
     */
    return new Date(timestamp + "Z").toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      })
}

export const capitalizeName = (name) => {
  if (!name) return '';
  return name
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}

export const isEmpty =(map) => {
  if (!map || map.size === 0) return true;

  for (const [, value] of map.entries()) {
    if (value === null || value === undefined) continue;
    if (typeof value === 'string' && value.trim() === '') continue;
    if (Array.isArray(value) && value.length === 0) continue;
    if (typeof value === 'object' && Object.keys(value).length === 0) continue;

    // At least one non-empty value found
    return false;
  }

  return true;
}